import React, { useState, useEffect } from 'react';

const ProductSlideshow = ({ folderName = 'carpet', interval = 5000, className, style }) => {
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch all images from specified folder
  useEffect(() => {
    const fetchImagesFromFolder = async () => {
      try {
        const imageExtensions = ['jpg'];
        const foundImages = [];
        
        // Try to load images with various naming patterns
        // Since we can't list directory contents directly, we'll try common patterns
        const attempts = [];
        
        // Try numbered files (1-100)
        for (let i = 1; i <= 100; i++) {
          for (const ext of imageExtensions) {
            attempts.push(`/products/${folderName}/${folderName}-${i}.${ext}`);
          }
        }
        
        // Test each potential image path
        const imagePromises = attempts.map(async (imagePath) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(imagePath);
            img.onerror = () => resolve(null);
            img.src = imagePath;
          });
        });

        const results = await Promise.all(imagePromises);
        const validImages = results.filter(Boolean);
        
        // Remove duplicates and sort
        const uniqueImages = [...new Set(validImages)].sort();

        if (uniqueImages.length > 0) {
          setImages(uniqueImages);
        } else {
          // Fallback to default images if no images found in folder
          console.warn(`No images found in folder: ${folderName}`);
          setImages(['/assets/tapis.svg', '/assets/couette.svg', '/assets/sac.svg']);
        }
        
        setIsLoading(false);
      } catch (error) {
        console.error('Error loading images from folder:', error);
        // Fallback to default images
        setImages(['/assets/tapis.svg', '/assets/couette.svg', '/assets/sac.svg']);
        setIsLoading(false);
      }
    };

    fetchImagesFromFolder();
  }, [folderName]);

  // Auto-rotate images
  useEffect(() => {
    if (images.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        // Get random index different from current
        let newIndex;
        do {
          newIndex = Math.floor(Math.random() * images.length);
        } while (newIndex === prevIndex && images.length > 1);
        return newIndex;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  if (isLoading) {
    return (
      <div 
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f3f4f6',
          borderRadius: 16
        }}
      >
        <span style={{ color: '#64748b' }}>Chargement...</span>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div 
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f3f4f6',
          borderRadius: 16
        }}
      >
        <span style={{ color: '#64748b' }}>Aucune image trouvée dans le dossier {folderName}</span>
      </div>
    );
  }

  return (
    <div 
      className={className}
      style={{
        ...style,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 16
      }}
    >
      {images.map((image, index) => (
        <img
          key={image}
          src={image}
          alt={`Produit ${folderName} ${index + 1}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: index === 0 ? 'static' : 'absolute',
            top: 0,
            left: 0,
            opacity: index === currentImageIndex ? 1 : 0,
            transition: 'opacity 0.8s ease-in-out'
          }}
        />
      ))}
      
      {/* Optional: Add dots indicator */}
      {/* {images.length > 1 && (
        <div style={{
          position: 'absolute',
          bottom: 12,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 6
        }}>
          {images.map((_, index) => (
            <div
              key={index}
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: index === currentImageIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                transition: 'background-color 0.3s ease'
              }}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default ProductSlideshow;